import Check from '../src/Check/index.tsx';
export default Check;
